var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.827148H513V342.794H0V0.827148Z",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.86H211.913V257.327H0V171.86ZM301.087 171.86H513V257.327H301.087V171.86Z",
    fill: "#3A9927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.827148V86.2938H211.913V0.827148H301.087V86.2938H513V0.827148H0Z",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.087 86.2939H513V171.761H301.087V86.2939ZM0 86.2939H211.913V171.761H0V86.2939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.087 342.794H211.913V257.327H0V342.794H513V257.327H301.087V342.794ZM105.906 9.44385L114.523 35.695H142.077L119.733 51.9267L128.35 78.1778L105.906 61.9462L83.5629 78.1778L92.0795 51.9267L69.7359 35.695H97.3898L105.906 9.44385Z",
    fill: "#FFCE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.827148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/CF.b194c29d05e9298ea18a5d441ecedc48.svg";
export { ForwardRef as ReactComponent };